<template>
  <form :id="widgetType" @submit.prevent="addNewWidget">
    <label for="" class="form-label">Nombre de Variable</label>
    <input required
      class="form-control"
      v-model="widgetConfig.variableFullName"
      label="Var Name"
      type="text"
    />

    <div>
      <label for="" class="form-label">ID Variable</label>
      <input
        class="form-control"
        v-model="widgetConfig.variable"
        type="text"
      />
    </div>
    
    <label for="" class="form-label">Seleccionar Tamaño</label>
    <select
      v-model="widgetConfig.column"
      class="form-select"
      placeholder="Seleccionar Tamaño"
      style="width: 100%"
      required
    >
      <option value="col-md-6 col-sm-12" label="Mediano"></option>
      <option value="col-12" label="Grande"></option>
    </select>
  </form>
</template>
<script>
export default {
  props: ["widgetConfig", "addNewWidget", "validateCount", "widgetType"],
};
</script>
